import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Form, Spinner } from "react-bootstrap";
import { changeFournisseurPassword } from "../api/api";
import PasswordInput from "../components/PasswordInput";

export default function FournisseurChangePassword() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirm) {
      setError("Confirmation mot de passe incorrecte.");
      return;
    }

    try {
      setLoading(true);
      await changeFournisseurPassword(currentPassword, newPassword);
      localStorage.setItem("fournisseur_must_change_password", "false");
      navigate("/fournisseur/dashboard", { replace: true });
    } catch (err) {
      const data = err?.response?.data || {};
      setError(
        data?.detail ||
        data?.old_password?.[0] ||
        data?.new_password?.[0] ||
        err.message ||
        "Erreur lors du changement de mot de passe."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 560 }}>
      <span className="profile-eyebrow">Securite</span>
      <h2 className="mb-3" style={{ fontWeight: 950, letterSpacing: "-0.04em" }}>
        Changer mot de passe
      </h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Mot de passe actuel</Form.Label>
          <PasswordInput
            inputClassName="form-control"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Nouveau mot de passe</Form.Label>
          <PasswordInput
            inputClassName="form-control"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Confirmer nouveau mot de passe</Form.Label>
          <PasswordInput
            inputClassName="form-control"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </Form.Group>

        <Button type="submit" disabled={loading}>
          {loading ? <Spinner size="sm" className="me-2" /> : null}
          Valider
        </Button>
      </Form>
    </div>
  );
}
